import React from 'react'
import { List, ListItem, ListItemText, Tooltip } from '@mui/material'
import { MaintenanceItem } from 'types/graphql'

const TaskCountTextWithToolip = ({
  taskDetail,
  tasks,
}: {
  taskDetail: string
  tasks: MaintenanceItem[]
}) => {
  return (
    <>
      <Tooltip
        classes={{
          tooltip: 'max-w-[800px]',
        }}
        title={
          <List disablePadding={true}>
            {tasks.map((task) => (
              <ListItem key={task.id}>
                <ListItemText
                  primary={`${
                    task.ataManufactureCode
                      ? `(${task.ataManufactureCode}) `
                      : ' '
                  }${task.mtxItem?.title ?? task.title}`}
                />
              </ListItem>
            ))}
          </List>
        }
      >
        <span
          style={{
            cursor: 'pointer',
            textDecorationLine: 'underline',
            textDecorationStyle: 'dotted',
          }}
        >
          {taskDetail}
        </span>
      </Tooltip>
    </>
  )
}

export default TaskCountTextWithToolip
